module.exports = __webpack_public_path__ + "img/normal_multiplier_1.3c0cb09e.png";